import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import '../theme/scss/styles.scss';
import { isMobile } from 'react-device-detect';
import { authorizedCheck } from '../modules/Authorized/actions';
import { getLayoutByRole, getRouteByRole, calculateBaseRoute } from '../utils/routeByRoles';
import { endLoadApp, initApp } from '../modules/System/actions';
import { getAuthorizedData } from '../modules/Authorized/reducer';
import ErrorPage from '../modules/System/components/ErrorPage';
import Loader from './base/Loader/Loader';

export default function Main() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    loggedIn, authorizedData, loadingAuthorizedCheck, loginProcess,
  } = useSelector(getAuthorizedData);
  const permissions = authorizedData && authorizedData.role && authorizedData.role.permissions ? authorizedData.role.permissions : {};

  useEffect(() => {
    dispatch(initApp());
    document.title = formatMessage({ id: 'app.title' });
    if (loggedIn) {
      dispatch(authorizedCheck())
        .then(() => {
          setTimeout(() => { dispatch(endLoadApp()); }, 800);
        })
        .catch(() => {});
    } else if (!loginProcess && !loadingAuthorizedCheck) {
      dispatch(endLoadApp());
    }
  }, [dispatch, loggedIn, formatMessage]);

  if (loggedIn && loadingAuthorizedCheck) {
    return <Loader loading global hideScreen />;
  }

  const currentRoutes = getRouteByRole(loggedIn, permissions, null, isMobile);
  const currentRoutesByMenu = getRouteByRole(loggedIn, permissions, null, isMobile, true);
  const CurrentLayout = getLayoutByRole(loggedIn, isMobile);
  calculateBaseRoute(true, permissions, null, isMobile, true);
  const router = createBrowserRouter([
    {
      element: <CurrentLayout currentRoutes={currentRoutes} currentRoutesByMenu={currentRoutesByMenu} />,
      children: currentRoutes,
      errorElement: <ErrorPage />,
    },
  ]); // todo по идее можно сделать разделение всех страниц по своим лаяутам. Но вот например у некоторых урлов может быть разные лаяуты
  return (
    <RouterProvider router={router} />
  );
}
